export const faqTestData = {
  result: [
    {
      id: 1,
      faqType: "콜잡기",
      title: "콜잡기는 어떻게 하나요?",
      question: "FAQ QUESTION1",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 2,
      faqType: "콜잡기",
      title: "콜잡기 어케함",
      question: "콜잡기 어케함진짜 어케하냐고 진짜로아아아아아아아",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 3,
      faqType: "콜잡기",
      title: "콜잡기는 이젠 모르겠다",
      question: "콜잡기는 이젠 모르겠다",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 4,
      faqType: "운행",
      title: "운행에 있어 문의드립니다",
      question: "FAQ QUESTION2-1",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER2-1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 5,
      faqType: "운행",
      title: "운행에 있어 문의드립니다",
      question: "FAQ QUESTION2-2",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER2-1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 6,
      faqType: "운행",
      title: "운행에 있어 문의드립니다",
      question: "FAQ QUESTION2-3",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER2-1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 7,
      faqType: "반납",
      title: "반납 어디서 해야되요?",
      question: "FAQ QUESTION3-1",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER3-1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 8,
      faqType: "반납",
      title: "반납 어디서 해야되요?",
      question: "FAQ QUESTION3-2",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER3-2 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 9,
      faqType: "반납",
      title: "반납 어디서 해야되요?",
      question: "FAQ QUESTION3-3",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER3-3 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 10,
      faqType: "정산",
      title: "정산 신청은 어떻게 하나요?",
      question: "FAQ QUESTION4-1",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER4-1 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 11,
      faqType: "정산",
      title: "정산 신청은 어떻게 하나요?",
      question: "FAQ QUESTION4-2",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER4-2 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },
    {
      id: 12,
      faqType: "정산",
      title: "정산 신청은 어떻게 하나요?",
      question: "FAQ QUESTION4-3",
      imageUrl: "2023725/c5c3bb12-ee83-480a-be7b-fdd6f7254cae.jpg",
      answer: "FAQ ANSWER4-3 update 했어요 수정 ",
      state: true,
      adminId: "admin",
      createdDate: "2023-07-12T02:54:01Z",
      lastModifiedDate: "2023-07-25T03:18:28Z",
    },

    {
      id: 13,
      faqType: "탈퇴",
      title: "탈퇴는 어떻게 하나요?",
      question: "test5-1",
      imageUrl: null,
      answer: "test5-1",
      state: true,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 14,
      faqType: "탈퇴",
      title: "탈퇴는 어떻게 하나요?",
      question: "test5-2",
      imageUrl: null,
      answer: "test5-2",
      state: true,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 15,
      faqType: "탈퇴",
      title: "탈퇴는 어떻게 하나요?",
      question: "탈퇴 test5-3",
      imageUrl: null,
      answer: "탈퇴 test5-3",
      state: true,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 16,
      faqType: "가입/탈퇴",
      title: "어쩌구 저쩌구 하나요?1",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "test2",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 17,
      faqType: "가입/탈퇴",
      title: "어쩌구 저쩌구 하나요?2",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST2",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 18,
      faqType: "예약/취소",
      title: "어쩌구 저쩌구 하나요?3",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST3",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 19,
      faqType: "예약/취소",
      title: "어쩌구 저쩌구 하나요?4",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST4",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 20,
      faqType: "차량점검",
      title: "어쩌구 저쩌구 하나요?5",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST5",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 21,
      faqType: "가입/탈퇴",
      title: "어쩌구 저쩌구 하나요?6",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST6",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
    {
      id: 22,
      faqType: "가입/탈퇴",
      title: "어쩌구 저쩌구 하나요?7",
      question: "어쩌구 저쩌구 하나요?1",
      imageUrl: null,
      answer: "상세 내용 TEST7",
      state: false,
      adminId: "testmaster",
      createdDate: "2023-07-18T01:43:35Z",
      lastModifiedDate: "2023-07-18T01:43:35Z",
    },
  ],
  listSize: 50,
  totalListCount: 2,
  message: "Success",
  currentPageIndex: 0,
  status: "RSLT0001",
};

export const qnaTestData = {
  result: [
    {
      id: 6,
      userId: 2,
      email: "dsada@naver.com",
      phone: "01023232323",
      deviceType: "a",
      appVersion: "1.0.2",
      category: "test",
      question: "인생이란 무엇일까요?",
      imageUrl: null,
      answer:
        '<p>:)</p><figure className="image"><img src="https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png"></figure>',
      attachedImage: null,
      answerDate: null,
      answerAdmin: "tester",
      state: true,
      createdDate: "2023-07-26T07:21:14Z",
      lastModifiedDate: "2023-07-26T07:38:48Z",
      isDelete: false,
      userName: "김창식",
      userType: "1",
      userState: "1",
    },
    {
      id: 5,
      userId: 2,
      email: "dsada@naver.com",
      phone: "01023232323",
      deviceType: "a",
      appVersion: "1.0.2",
      category: "test",
      question:
        "인생이란 무엇일까요? 저는 진심 1도 모르겠습니다 정말로요 그래도 하루하루 힘내가면서 살고 있는데 어쩌면 좋을까요",
      imageUrl: null,
      answer: "제가 어떻게 압니까 ㅇㄴㅇㄴㅁ 으헹헹웅행",
      attachedImage: null,
      answerDate: null,
      answerAdmin: "tester",
      state: true,
      createdDate: "2023-07-26T07:21:12Z",
      lastModifiedDate: "2023-07-26T07:38:56Z",
      isDelete: false,
      userName: "김창식",
      userType: "1",
      userState: "1",
    },
    {
      id: 4,
      userId: 3,
      email: "dsadsad",
      phone: "01012345678",
      deviceType: "a",
      appVersion: "1.1.0",
      category: "test",
      question: "qqqqqqqqqqqqqqqqq",
      imageUrl: null,
      answer:
        '<figure className="image"><img src="https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/437e5e4b-b422-4614-9fea-58043ff48508.jpg"></figure><p>test2ㅇㄴㅁ</p><p>&nbsp;</p>',
      attachedImage: null,
      answerDate: "2023-07-14T08:25:39Z",
      answerAdmin: "admin",
      state: true,
      createdDate: "2023-07-14T03:39:08Z",
      lastModifiedDate: "2023-07-20T08:53:16Z",
      isDelete: false,
      userName: "김창식",
      userType: "1",
      userState: "1",
    },
    {
      id: 2,
      userId: 2,
      email: "test@naver.com",
      phone: "01000000000",
      deviceType: "a",
      appVersion: "1.0.0",
      category: "test",
      question: "test",
      imageUrl: [
        "https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png",
        "https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png",
        "https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png",
        "https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png",
        "https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png",
      ],
      answer:
        '<p>testㅇㅁㄴㅇㄴㅁㅇㄴㅁㅇㄴㅁㅇㅁㄴㅇ</p><figure className="image"><img src="https://videoend-image-storage.s3.ap-northeast-2.amazonaws.com/default/d3dbc4c7-dbc9-483c-81ff-c05e6a64bb32.png"></figure>',
      attachedImage: "\"{'imageUrl': 'imageurl.com'}\"",
      answerDate: null,
      answerAdmin: "admin",
      state: true,
      createdDate: "2023-07-14T01:44:22Z",
      lastModifiedDate: "2023-07-26T05:17:42Z",
      isDelete: false,
      userName: "김창식",
      userType: "1",
      userState: "1",
    },
    {
      id: 1,
      userId: 1,
      email: "test@naver.com",
      phone: "01000000000",
      deviceType: "i",
      appVersion: "1.0.0",
      category: "test",
      question: "test",
      imageUrl: null,
      answer:
        '<figure className="image"><img src="https://movers-devrock.s3.ap-northeast-2.amazonaws.com/2023726/61d4fd82-6bdc-477f-a564-36b6c53fb449.jpg"></figure><p>ㅇㄴㅁㅇㄴㅁ</p>',
      attachedImage: "\"{'imageUrl': 'imageurl.com'}\"",
      answerDate: null,
      answerAdmin: "admin",
      state: true,
      createdDate: "2023-07-14T01:44:22Z",
      lastModifiedDate: "2023-07-26T07:16:41Z",
      isDelete: false,
      userName: "이상헌",
      userType: "1",
      userState: "1",
    },
  ],
  listSize: 50,
  totalListCount: 5,
  message: "Success",
  currentPageIndex: 0,
  status: "RSLT0001",
};

export const QnaCategory = [
  { value: null, name: "유형 선택" },
  { value: "call", name: "콜잡기" },
  { value: "drive", name: "운행" },
  { value: "back", name: "반납" },
  { value: "calulate", name: "정산" },
  { value: "draw", name: "탈퇴" },
];

export const CallTestData = {
  result: [
    {
      id: 201,
      randomCode: "zzM02L",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T17:00:02",
      endAt: "2023-08-13T22:00:02",
      deadLineAt: "2023-08-14T04:00:02",
      openAt: "2023-08-13T16:00:02",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T08:00:02Z",
      lastModifiedDate: "2023-08-13T08:00:02Z",
      userState: 0,
      userName: null,
    },
    {
      id: 200,
      randomCode: "5xsB4L",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T17:00:02",
      endAt: "2023-08-13T22:00:02",
      deadLineAt: "2023-08-14T04:00:02",
      openAt: "2023-08-13T16:00:02",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T08:00:01Z",
      lastModifiedDate: "2023-08-13T08:00:01Z",
      userState: 0,
      userName: null,
    },
    {
      id: 199,
      randomCode: "882fZw",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:35:01",
      endAt: "2023-08-13T21:35:01",
      deadLineAt: "2023-08-14T03:35:01",
      openAt: "2023-08-13T15:35:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T07:35:01Z",
      lastModifiedDate: "2023-08-13T07:35:01Z",
      userState: 0,
      userName: null,
    },
    {
      id: 198,
      randomCode: "KiqC77",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:35:01",
      endAt: "2023-08-13T21:35:01",
      deadLineAt: "2023-08-14T03:35:01",
      openAt: "2023-08-13T15:35:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T07:35:01Z",
      lastModifiedDate: "2023-08-13T07:35:01Z",
      userState: 0,
      userName: null,
    },
    {
      id: 196,
      randomCode: "zudJ9M",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:06:01",
      endAt: "2023-08-13T20:06:01",
      deadLineAt: "2023-08-14T02:06:01",
      openAt: "2023-08-13T14:06:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:06:00Z",
      lastModifiedDate: "2023-08-13T06:06:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 195,
      randomCode: "4YVn4t",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:06:01",
      endAt: "2023-08-13T20:06:01",
      deadLineAt: "2023-08-14T02:06:01",
      openAt: "2023-08-13T14:06:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:06:00Z",
      lastModifiedDate: "2023-08-13T06:06:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 194,
      randomCode: "pdUHug",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:05:01",
      endAt: "2023-08-13T20:05:01",
      deadLineAt: "2023-08-14T02:05:01",
      openAt: "2023-08-13T14:05:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:05:00Z",
      lastModifiedDate: "2023-08-13T06:05:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 193,
      randomCode: "q6H10K",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:05:01",
      endAt: "2023-08-13T20:05:01",
      deadLineAt: "2023-08-14T02:05:01",
      openAt: "2023-08-13T14:05:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:05:00Z",
      lastModifiedDate: "2023-08-13T06:05:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 192,
      randomCode: "A3G828",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:04:01",
      endAt: "2023-08-13T20:04:01",
      deadLineAt: "2023-08-14T02:04:01",
      openAt: "2023-08-13T14:04:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:04:00Z",
      lastModifiedDate: "2023-08-13T06:04:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 191,
      randomCode: "yXJr0t",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T15:04:01",
      endAt: "2023-08-13T20:04:01",
      deadLineAt: "2023-08-14T02:04:01",
      openAt: "2023-08-13T14:04:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T06:04:00Z",
      lastModifiedDate: "2023-08-13T06:04:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 190,
      randomCode: "2q66UC",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:51:01",
      endAt: "2023-08-13T19:51:01",
      deadLineAt: "2023-08-14T01:51:01",
      openAt: "2023-08-13T13:51:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:51:00Z",
      lastModifiedDate: "2023-08-13T05:51:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 189,
      randomCode: "jyW9RV",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:51:01",
      endAt: "2023-08-13T19:51:01",
      deadLineAt: "2023-08-14T01:51:01",
      openAt: "2023-08-13T13:51:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:51:00Z",
      lastModifiedDate: "2023-08-13T05:51:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 188,
      randomCode: "eHI1DE",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:50:01",
      endAt: "2023-08-13T19:50:01",
      deadLineAt: "2023-08-14T01:50:01",
      openAt: "2023-08-13T13:50:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:50:00Z",
      lastModifiedDate: "2023-08-13T05:50:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 187,
      randomCode: "9N2dSJ",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:50:01",
      endAt: "2023-08-13T19:50:01",
      deadLineAt: "2023-08-14T01:50:01",
      openAt: "2023-08-13T13:50:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:50:00Z",
      lastModifiedDate: "2023-08-13T05:50:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 186,
      randomCode: "hcteu4",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:49:01",
      endAt: "2023-08-13T19:49:01",
      deadLineAt: "2023-08-14T01:49:01",
      openAt: "2023-08-13T13:49:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:49:00Z",
      lastModifiedDate: "2023-08-13T05:49:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 185,
      randomCode: "x5f79F",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T14:49:01",
      endAt: "2023-08-13T19:49:01",
      deadLineAt: "2023-08-14T01:49:01",
      openAt: "2023-08-13T13:49:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-13T05:49:00Z",
      lastModifiedDate: "2023-08-13T05:49:00Z",
      userState: 0,
      userName: null,
    },
    {
      id: 184,
      randomCode: "54Dl0G",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:41:00",
      endAt: "2023-08-13T21:41:00",
      deadLineAt: "2023-08-14T03:41:00",
      openAt: "2023-08-13T15:41:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:40:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 183,
      randomCode: "h0SstE",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:41:00",
      endAt: "2023-08-13T21:41:00",
      deadLineAt: "2023-08-14T03:41:00",
      openAt: "2023-08-13T15:41:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:40:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 182,
      randomCode: "dL24y1",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:40:00",
      endAt: "2023-08-13T21:40:00",
      deadLineAt: "2023-08-14T03:40:00",
      openAt: "2023-08-13T15:40:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:39:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 181,
      randomCode: "PAeks6",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:40:00",
      endAt: "2023-08-13T21:40:00",
      deadLineAt: "2023-08-14T03:40:00",
      openAt: "2023-08-13T15:40:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:39:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 180,
      randomCode: "Lpvtbk",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:39:00",
      endAt: "2023-08-13T21:39:00",
      deadLineAt: "2023-08-14T03:39:00",
      openAt: "2023-08-13T15:39:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:38:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 179,
      randomCode: "kcKMHP",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:39:00",
      endAt: "2023-08-13T21:39:00",
      deadLineAt: "2023-08-14T03:39:00",
      openAt: "2023-08-13T15:39:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:38:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 178,
      randomCode: "cujlOz",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:38:00",
      endAt: "2023-08-13T21:38:00",
      deadLineAt: "2023-08-14T03:38:00",
      openAt: "2023-08-13T15:38:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:37:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 177,
      randomCode: "jZ6q1M",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:38:00",
      endAt: "2023-08-13T21:38:00",
      deadLineAt: "2023-08-14T03:38:00",
      openAt: "2023-08-13T15:38:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:37:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 176,
      randomCode: "2m0lgv",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:37:00",
      endAt: "2023-08-13T21:37:00",
      deadLineAt: "2023-08-14T03:37:00",
      openAt: "2023-08-13T15:37:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:36:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 175,
      randomCode: "16F50l",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:37:00",
      endAt: "2023-08-13T21:37:00",
      deadLineAt: "2023-08-14T03:37:00",
      openAt: "2023-08-13T15:37:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:36:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 174,
      randomCode: "txBby3",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:36:01",
      endAt: "2023-08-13T21:36:01",
      deadLineAt: "2023-08-14T03:36:01",
      openAt: "2023-08-13T15:36:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:36:00Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 173,
      randomCode: "5tW1ga",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:36:01",
      endAt: "2023-08-13T21:36:01",
      deadLineAt: "2023-08-14T03:36:01",
      openAt: "2023-08-13T15:36:01",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:36:00Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 172,
      randomCode: "aChH6N",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:35:00",
      endAt: "2023-08-13T16:35:00",
      deadLineAt: "2023-08-13T19:35:00",
      openAt: "2023-08-13T15:35:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:34:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 171,
      randomCode: "69h2w3",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:35:00",
      endAt: "2023-08-13T16:35:00",
      deadLineAt: "2023-08-13T19:35:00",
      openAt: "2023-08-13T15:35:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:34:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 170,
      randomCode: "0xJDeI",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:34:00",
      endAt: "2023-08-13T16:34:00",
      deadLineAt: "2023-08-13T19:34:00",
      openAt: "2023-08-13T15:34:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:33:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 169,
      randomCode: "8l1GYp",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:34:00",
      endAt: "2023-08-13T16:34:00",
      deadLineAt: "2023-08-13T19:34:00",
      openAt: "2023-08-13T15:34:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:33:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 168,
      randomCode: "lz0n4g",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:33:00",
      endAt: "2023-08-13T16:33:00",
      deadLineAt: "2023-08-13T19:33:00",
      openAt: "2023-08-13T15:33:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:32:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 167,
      randomCode: "C14B18",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:33:00",
      endAt: "2023-08-13T16:33:00",
      deadLineAt: "2023-08-13T19:33:00",
      openAt: "2023-08-13T15:33:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:32:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 166,
      randomCode: "WAK4z3",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:32:00",
      endAt: "2023-08-13T16:32:00",
      deadLineAt: "2023-08-13T19:32:00",
      openAt: "2023-08-13T15:32:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:31:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 165,
      randomCode: "8jL5kf",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:32:00",
      endAt: "2023-08-13T16:32:00",
      deadLineAt: "2023-08-13T19:32:00",
      openAt: "2023-08-13T15:32:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:31:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 164,
      randomCode: "WX9feI",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:31:00",
      endAt: "2023-08-13T16:31:00",
      deadLineAt: "2023-08-13T19:31:00",
      openAt: "2023-08-13T15:31:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:30:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 163,
      randomCode: "07O640",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:31:00",
      endAt: "2023-08-13T16:31:00",
      deadLineAt: "2023-08-13T19:31:00",
      openAt: "2023-08-13T15:31:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:30:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 162,
      randomCode: "91D7VZ",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:30:00",
      endAt: "2023-08-13T16:30:00",
      deadLineAt: "2023-08-13T19:30:00",
      openAt: "2023-08-13T15:30:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:29:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 161,
      randomCode: "51HTbZ",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:30:00",
      endAt: "2023-08-13T16:30:00",
      deadLineAt: "2023-08-13T19:30:00",
      openAt: "2023-08-13T15:30:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:29:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 160,
      randomCode: "dmdotI",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:29:00",
      endAt: "2023-08-13T16:29:00",
      deadLineAt: "2023-08-13T19:29:00",
      openAt: "2023-08-13T15:29:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:28:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 159,
      randomCode: "YwY7K2",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:29:00",
      endAt: "2023-08-13T16:29:00",
      deadLineAt: "2023-08-13T19:29:00",
      openAt: "2023-08-13T15:29:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:28:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 158,
      randomCode: "VjPgR3",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:28:00",
      endAt: "2023-08-13T16:28:00",
      deadLineAt: "2023-08-13T19:28:00",
      openAt: "2023-08-13T15:28:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:27:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 157,
      randomCode: "o8K1dx",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:28:00",
      endAt: "2023-08-13T16:28:00",
      deadLineAt: "2023-08-13T19:28:00",
      openAt: "2023-08-13T15:28:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:27:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 156,
      randomCode: "1ZnIZ5",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:27:00",
      endAt: "2023-08-13T16:27:00",
      deadLineAt: "2023-08-13T19:27:00",
      openAt: "2023-08-13T15:27:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:26:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 155,
      randomCode: "n99yXC",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:27:00",
      endAt: "2023-08-13T16:27:00",
      deadLineAt: "2023-08-13T19:27:00",
      openAt: "2023-08-13T15:27:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:26:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 154,
      randomCode: "066r1X",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:26:00",
      endAt: "2023-08-13T16:26:00",
      deadLineAt: "2023-08-13T19:26:00",
      openAt: "2023-08-13T15:26:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:25:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 153,
      randomCode: "9K63xc",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:26:00",
      endAt: "2023-08-13T16:26:00",
      deadLineAt: "2023-08-13T19:26:00",
      openAt: "2023-08-13T15:26:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:25:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 152,
      randomCode: "rwY3Mm",
      userId: null,
      carId: 12,
      carName: "DUMMY2",
      carNumber: "111헣1111",
      startZoneId: 5525,
      endZoneId: 6646,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:25:00",
      endAt: "2023-08-13T16:25:00",
      deadLineAt: "2023-08-13T19:25:00",
      openAt: "2023-08-13T15:25:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 26,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "경기",
      startAddress02: "남양주시 별내동 929",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n다이소 옆 골목으로 진입합니다. ▶ 커피스미스 건너편 지상 야외 주차장 내 그린카 위치   \n\n[반납 시]\n경기 남양주시 별내동 929번지 별내미디어 주차장 내 그린카 반납",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "부산",
      endAddress02: "해운대구 우동 649-2",
      endAddressType: "",
      endAddressGuide: "선상A주차장1층(계단내려오면앞줄)",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:24:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
    {
      id: 151,
      randomCode: "6ZKXz2",
      userId: null,
      carId: 1,
      carName: "DUMMY",
      carNumber: "111헣1111",
      startZoneId: 1423,
      endZoneId: 2234,
      type: "편도",
      state: 0,
      startAt: "2023-08-13T16:25:00",
      endAt: "2023-08-13T16:25:00",
      deadLineAt: "2023-08-13T19:25:00",
      openAt: "2023-08-13T15:25:00",
      matchAt: null,
      onboardAt: null,
      returnAt: null,
      forceEndAt: null,
      forceEndReason: null,
      driverAge: null,
      driverAgeLimit: 21,
      distance: 0,
      startLng: 127.1,
      startLat: 38.1,
      startAddress01: "서울",
      startAddress02: "강동구 명일동 47-12 고덕복합빌딩",
      startAddressType: "",
      startAddressGuide:
        "[픽업 시]\n서울역 1번출구 ▶ 롯데마트 건물 좌측에 위치한 한화역사 주차장 계단 진입 ▶ 지상4층 옥외 주차장 내 그린카 위치\n\n[반납 시]\n서울특별시 용산구 동자동 43-205 지상4층 옥외 주차장에  반납\n",
      endLng: 127.1,
      endLat: 38.1,
      endAddress01: "서울",
      endAddress02: "마포구 성산동 370 마포구청",
      endAddressType: "",
      endAddressGuide:
        "▶[픽업 시]\n양천구의회,양천구보건소 길건너 양천공원 도로 옆 노상 유료주차장 그린카 위치\n\n▶[반납 시]\n서울 양천구 신정동 321-3 양천구청 앞 노상공영주차장에 반납.\n",
      deviceType: null,
      deviceUid: null,
      isDelete: false,
      createdDate: "2023-08-11T07:24:59Z",
      lastModifiedDate: "2023-08-13T04:51:56Z",
      userState: 0,
      userName: null,
    },
  ],
  pageSize: 10,
  listSize: 50,
  totalListCount: 182,
  message: "SUCCESS",
  status: "RSLT0001",
};

export const drawalReason = [
  { id: 1, text: "차량 탁송업을 그만두어요." },
  { id: 2, text: "다른 탁송 서비스를 이용해요." },
  { id: 3, text: "운영 가능한 콜이 많지 않아요." },
  { id: 4, text: "운영 방식이 만족스럽지 않아요." },
  { id: 5, text: "기타" },
];